import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Typography, Container, Chip } from "@mui/material";
import SchoolIcon from "@mui/icons-material/School";
import CloudIcon from "@mui/icons-material/Cloud";
import LogoutIcon from "@mui/icons-material/Logout";

import { ACTIONS as MAIN_ACTIONS } from "../../../redux/main";
import { ACTIONS as UI_ACTIONS } from "../../../redux/ui";
import DrawerItem from "../../../components/drawer-item";

import AvatarPicker from "../../../components/avatar-picker";
import NotFoundMessage from "../../../components/not-found-message";
import UploadButton from "../../../components/upload-button";
import UploadFileModal from "../../../components/upload-file-modal";
import Loader from "../../../components/loader";
import ImageList from "../../../components/image-list";
import ModalImage from "../../../components/modal-image";

import LogOutButton from "./log-out";
import StyledSearchprofilePage from "./styles";

const SearchProfilePage = ({ props }) => {
  const { user, api, init } = useSelector((state) => state.main);

  const dispatch = useDispatch();

  const [modalState, setModalState] = useState({
    open: false,
    props: {},
  });

  const [modalImageState, setModalImageState] = useState({
    open: false,
    props: {},
  });

  const onImagePick = (image) => {
    const data = image?.filesContent[0]?.content;
    let extension = image?.plainFiles[0]?.type;
    extension = extension.replace("image/", "");

    dispatch(MAIN_ACTIONS.uploadProfileImage({ extension, data }));
  };

  const onModalClose = () => {
    setModalState({
      open: false,
      props: {},
    });
  };

  const onModalImageClose = () => {
    setModalImageState({ open: false, props: {} });
  };

  const onImageModalOpen = (img) => {
    setModalImageState({ open: true, props: img });
  };

  const onFileSelectHandler = (file) => {
    const data = file?.filesContent[0]?.content;
    const name = file?.filesContent[0]?.name;
    const type = file?.plainFiles[0]?.type;
    let extension = type.replace("image/", "");
    extension = extension.replace("application/", "");

    setModalState({
      open: true,
      props: { data, name, type, extension },
    });
  };

  const onUploadFile = () => {
    const { extension, data, name, type } = modalState.props;

    dispatch(MAIN_ACTIONS.uploadFile({ extension, data, name, type }));
    setModalState({ open: false, props: {} });
  };

  const onFilePickerError = (error) => {
    dispatch(
      MAIN_ACTIONS.requestFail({ message: "No pudimos subir el archivo" })
    );
  };

  const onLogOutClick = () => {};

  return (
    <StyledSearchprofilePage>
      <div className="profile-background-image">
        <img
          src={process.env.PUBLIC_URL + "/university.jpeg"}
          alt="biblioteca"
        />
      </div>

      <div className="search-profile-page">
        <Container maxWidth="md">
          <div className="search-profile-header">
            <div className="profile-picture">
              <AvatarPicker
                color="default"
                size={130}
                name={user?.name}
                surname={user?.surname}
                image={user?.profilePicture}
                loading={api.loading || !init}
                onPick={onImagePick}
                iconSize={35}
                onPickError={onFilePickerError}
              />
            </div>
            <div className="search-profile-content-container">
              <div className="search-profile-content">
                {user?.name && user?.surname && (
                  <Typography variant="h5">
                    {user.name} {user.surname}
                  </Typography>
                )}

                {user?.university && (
                  <div className="user-card-uni">
                    <SchoolIcon sx={{ width: 20, height: 20 }} />
                    <Typography variant="subtitle2">
                      {user.university}
                    </Typography>
                  </div>
                )}
              </div>
            </div>
          </div>
        </Container>
      </div>

      <div className="search-profile-main-info">
        <Container maxWidth="lg" className="search-profile-main-info-container">
          <div className="search-profile-main-i">
            <Typography variant="h6" sx={{ marginBottom: "0.5rem" }}>
              Información académica
            </Typography>

            <div className="search-profile-pill-cont">
              {user?.investigationGroup && (
                <div className="item-cont">
                  <div>
                    <Typography variant="subtitle2">
                      Grupos de investigación
                    </Typography>

                    <div className="pill-cont">
                      {user?.investigationGroup.map((e, i) => (
                        <Chip
                          label={e}
                          color="primary"
                          size="small"
                          key={`chat-${i}`}
                        />
                      ))}
                    </div>
                  </div>
                </div>
              )}

              {user?.investigationLines && (
                <div className="item-cont">
                  <div>
                    <Typography variant="subtitle2">
                      Líneas de investigación
                    </Typography>

                    <div className="pill-cont">
                      {user?.investigationLines.map((e) => (
                        <Chip label={e} color="primary" size="small" />
                      ))}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div>
            <div className="attachements-header">
              <Typography variant="h6" sx={{ marginBottom: "0.5rem" }}>
                Archivos adjuntos
              </Typography>
              <UploadButton
                onSelect={onFileSelectHandler}
                onError={onFilePickerError}
                loading={api.loading}
              >
                Subir archivo
              </UploadButton>
            </div>
            <div className="attachments-container">
              {user?.attachments?.length > 0 ? (
                <ImageList
                  attachments={user.attachments}
                  onImageClick={onImageModalOpen}
                  maxHeight="300px"
                />
              ) : (
                <NotFoundMessage
                  message="No hay archivos adjuntos"
                  Icon={CloudIcon}
                />
              )}
            </div>
            <LogOutButton />
          </div>
        </Container>
      </div>

      <ModalImage
        open={modalState.open}
        url={modalState.props.data}
        onClose={onModalClose}
        onButtonClick={onUploadFile}
        buttonLabel="Subir archivo"
        loading={api.loading}
      />

      <ModalImage
        open={modalImageState.open}
        onClose={onModalImageClose}
        {...modalImageState.props}
      />
    </StyledSearchprofilePage>
  );
};

export default SearchProfilePage;
